export default {
    namespaced: true,
    state: {
        show: {
            legislatif: false,
            glossaire: false,
            tarifs: false,
            simulateur: true,
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/Show/index.js